/**
 * Reusable read/edit text section for the Handbook (Heizung, Müll, Schlüssel, Notes).
 */
export function TextSection({ title, testid, editing, value, onChange, rows = 3, spanFull = false }) {
  return (
    <section
      className={`bg-white border border-navy/10 p-6 md:p-8 ${spanFull ? "lg:col-span-2" : ""}`}
      data-testid={testid}
    >
      <div className="label-caps mb-4">{title}</div>
      {editing ? (
        <textarea
          data-testid={`${testid}-input`}
          rows={rows}
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value)}
          className="w-full bg-white border border-navy/20 focus:border-gold focus:outline-none px-4 py-2.5 text-navy-dark leading-relaxed"
        />
      ) : (
        <p className="text-[14px] text-navy-dark leading-relaxed whitespace-pre-wrap">
          {value || "—"}
        </p>
      )}
    </section>
  );
}
